import { newRequest } from 'lib/v2/request.js';

// Legacy request with the `v1` hard coded
const prefix = '/v1';

export default newRequest({ prefix });
